import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
// Force every Date locale-string call to render in Baghdad time (Asia/Baghdad).
// Loaded BEFORE App so any component-level date formatter runs post-patch.
import "@/utils/baghdadTime";
import App from "@/App";

// Global 30-second timeout on every axios request so a stuck/slow request
// (Iraqi Wi-Fi hiccup, backend restart, dropped socket) never freezes the
// UI. Individual calls can still override with `axios.get(url, { timeout })`.
axios.defaults.timeout = 30000;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
